/**
 * @generated SignedSource<<1384392670aaa36d5f81c8594ee3dab5>>
 * @relayHash d717d6fbe65114dfe887ad9161552df8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d3055793b0e684ff8ef6e52072b1b4e29549724c4b1c2ace39b41aa2804a2c57

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { modal_EnforceStorageLimitQuery } from './modal_EnforceStorageLimitQuery.graphql';

const node: PreloadableConcreteRequest<modal_EnforceStorageLimitQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d3055793b0e684ff8ef6e52072b1b4e29549724c4b1c2ace39b41aa2804a2c57",
    "metadata": {},
    "name": "modal_EnforceStorageLimitQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
